import { render } from "./FAQWhatToDoSection.vue?vue&type=template&id=8d7161c6&scoped=true"
import script from "./FAQWhatToDoSection.vue?vue&type=script&lang=js"
export * from "./FAQWhatToDoSection.vue?vue&type=script&lang=js"

import "./FAQWhatToDoSection.vue?vue&type=style&index=0&id=8d7161c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7161c6"]])

export default __exports__